import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import AppointmentAltModel from "../../models/appointment-alt";

export default class AppointmentAltRepository extends BaseRepository {
  static modelClass = AppointmentAltModel;
  modelName = "appointment-alt";
}
